module.exports = __webpack_public_path__ + "img/74.2492a156.jpg";